export default "__VITE_ASSET__2ad2a50c__"